// import COMPANY_API from '@/api/masterData/company.js';
export const formFields = (ctx) => {
  return [
    {
      name: '指令单编号',
      prop: 'projectInitiationNo',
      type: 'input',
      // disabled: true,
      disabled: true,
    },

    {
      name: '采购组织',
      prop: 'receivableSettlementNo',
      disabled: true,
      type: 'input',
      // placeholder: '自动生成',
    },

    // {
    //   name: '汇率日期',
    //   prop: 'exchangeDate',
    //   type: 'date',
    //   disabled: true,
    // },
    {
      name: '服务供方',
      prop: 'exchangeRate',
      type: 'input',
      disabled: true,
      // disabled: true,
    },

    {
      name: '指令单状态',
      prop: 'settlementType',
      type: 'select',
      options: ctx.dictListMap?.settlementType || [],
      disabled: true,
    },

    {
      name: '服务下发时间',
      prop: 'settlementCreateDate',
      type: 'date',
      disabled: true,
    },
    {
      name: '最近更新时间',
      prop: 'settlementCreateDate',
      type: 'date',
      disabled: true,
    },
    {
      name: '舱位类型',
      prop: 'settlementType',
      type: 'select',
      options: ctx.dictListMap?.settlementType || [],
      disabled: true,
    },
    {
      name: '订舱要求',
      prop: 'originalTotalAmount',
      type: 'input',
      disabled: true,
    },
    {
      name: '启运站',
      prop: 'originalTotalAmount',
      type: 'input',
      disabled: true,
    },
    {
      name: '启运省份',
      prop: 'originalTotalAmount',
      type: 'input',
      disabled: true,
    },
    {
      name: '到达站',
      prop: 'originalTotalAmount',
      type: 'input',
      disabled: true,
    },
    {
      name: '到达省份',
      prop: 'originalTotalAmount',
      type: 'input',
      disabled: true,
    },
    {
      name: '服务类型',
      prop: 'settlementType',
      type: 'select',
      options: ctx.dictListMap?.settlementType || [],
      disabled: true,
    },
  ];
};
// 默认表头
export const defaultTableColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },

  // {
  //   field: 'orderCode',
  //   title: '订单编码',

  //   visible: true,
  // },
  // {
  //   field: 'instructCode',
  //   title: '指令编码',

  //   visible: true,
  // },
  {
    field: 'containerType',
    title: '箱型',
    width: '100',
    visible: true,
  },
  {
    field: 'containerNo',
    title: '集装箱号',
    width: '100',
    visible: true,
  },
  {
    field: 'suspendNo',
    title: '封号',
    visible: true,
    width: '100',
  },
  {
    field: 'bookDate',
    title: '订舱日期',
    visible: true,
    width: '100',
  },
  {
    field: 'rentProvider',
    title: '租箱供方',
    visible: true,
    width: '100',
  },
  {
    field: 'trainNo',
    title: '班列号',
    visible: true,
    width: '100',
  },
  {
    field: 'planTranStartDate',
    title: '计划开班日期',
    visible: true,
    width: '100',
  },
  {
    field: 'tranStartDate',
    title: '实际开班日期',
    visible: true,
    width: '100',
  },
  {
    field: 'railwayWaybillNo',
    title: '铁路运单号',
    visible: true,
    width: '100',
  },
  {
    field: 'stationUnloadDate',
    title: '站点卸车日期',
    visible: true,
    width: '100',
  },
  {
    field: 'rentDate',
    title: '租箱日期',
    width: '100',
    visible: true,
  },
  {
    field: 'productName',
    title: '货物品名',
    width: '100',
    visible: true,
  },
  {
    field: 'remarks',
    title: '备注',
    visible: true,
    width: '100',
  },
];
export const tableList = [
  {
    id: 1,
    payableSettlementNo: 1111,
    settlementDesc: '说明',
    companyName: 'A',
    departmentName: 'b',
    originalTotalAmount: 1,
    domesticTotalAmount: 1,
    currencyName: 'TEST',
    contractNo: 66666,
    projectInitiationNo: 88888,
    productName: '乐百氏',
  },
  {
    id: 2,
    payableSettlementNo: 2222,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 2,
    domesticTotalAmount: 2,
    currencyName: 'TEST',
    contractNo: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 3,
    payableSettlementNo: 3333,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 3,
    domesticTotalAmount: 3,
    currencyName: 'TEST',
    contractNo: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 4,
    payableSettlementNo: 4444,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 4,
    domesticTotalAmount: 4,
    currencyName: 'TEST',
    contractNo: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 5,
    payableSettlementNo: 5555,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 5,
    domesticTotalAmount: 5,
    currencyName: 'TEST',
    contractNo: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
];
